<template>
    <div class="model-picker-container">
        <h3>Choose Model</h3>
        <a v-if="showSeeSpecs" href="#key-features" class="see-specs" @click="showSpecs()">See Specs</a>
        <div class="model-picker">
            <div
                v-for="(build, index) in builds"
                :key="`case-${build.id}`"
                :class="{'selected': build.id == currentBuild.id, 'disable-element': isUpdating || build.id == currentBuild.id }"
                class="picker"
                @click="updateStarterPc(index)"
            >
                {{ build.description }}
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
    name: "ModelPicker",
    props: {
        showSeeSpecs: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapState({
            builds: state => state.StarterPc.builds,
            currentBuild: state => state.StarterPc.builds[state.StarterPc.buildsIndex],
            isUpdating: state => state.StarterPc.isUpdating
        })
    },
    methods: {
        ...mapActions({
            setRoute: "StarterPc/setRoute",
            updateModel: "StarterPc/updateModel"
        }),
        showSpecs() {
            EventBus.$emit("open-specs");
        },
        updateStarterPc(index) {
            this.setRoute(index == 0 ? "starter-pc" : "starter-pc-plus");
            this.updateModel(index);
        }
    }
}
</script>

<style lang="scss" scoped>
@import "~@s/_asset-mixers.scss";

h3 {
    text-transform: uppercase;

    @media (max-width: 580px) {
        font-size: 20px;
    }
}

.model-picker-container {
    position: relative;

    @media (min-width: 580px) and (max-width: 991px) {
        width: 100%;
        margin-top: 20px;
    }

    .see-specs {
        cursor: pointer;
        font-size: 16px;
        position: absolute;
        right: 0;
        top: 4px;
        color: $orchid;

        @media (min-width: 580px) and (max-width: 991px) {
            top: 25px;
            right: 0;
        }
    }
}

.model-picker {
    display: flex;
    margin-top: 12px;

    @media (max-width: 991px) {
        margin-top: 0;
    }

    .picker {
        height: 64px;
        width: 50%;
        padding: 10px 18px;
        border: 3px solid rgba(#dadde0, 0.6);
        border-radius: 2px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 16px;
        cursor: pointer;
        transition: all 0.2s;

        &:first-child {
            margin-right: 16px;
        }

        &:hover {
            border: 3px solid $orchid;
            color: $orchid;
        }
    }

    .selected {
        border: 3px solid $orchid;
        color: $orchid;
    }
}
</style>
